import React from "react";
import { ArrowRightLeft, Globe, Timer } from "lucide-react";
import { FadeUp } from "./FadeUp";

const POINTS = [
  {
    icon: Timer,
    title: "Live in about a minute",
    body: "Chat setup builds your contractor site now, not after a long software install.",
  },
  {
    icon: Globe,
    title: "Website, photos, licenses",
    body: "Local search, job-site photos, and license tracking. Not dispatch, job costing, or invoicing.",
  },
  {
    icon: ArrowRightLeft,
    title: "Works with your ops tools",
    body: "Use ToolKit for the site, job photos, and licenses. Keep schedules and billing in the app you already use.",
  },
] as const;

export const DifferentFromFsmSection: React.FC = () => (
  <section
    id="website-vs-field-service"
    className="py-16 sm:py-20 bg-muted/30 border-y border-border"
    aria-labelledby="website-vs-field-service-heading"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <h2
          id="website-vs-field-service-heading"
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground font-display text-center max-w-3xl mx-auto leading-tight mb-4"
        >
          Don&apos;t buy dispatch software to get a website.
        </h2>
        <p className="text-center text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto mb-10 sm:mb-12 leading-relaxed">
          Tools like{" "}
          <span className="text-foreground font-medium">Housecall Pro</span> and{" "}
          <span className="text-foreground font-medium">Jobber</span> run the
          calendar and the invoice. ToolKit gets you found, takes the quote,
          files the photos, and watches the licenses. Use both if you want. They
          are not the same product.
        </p>
        <div className="grid gap-6 md:grid-cols-3">
          {POINTS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-xl border border-border bg-card p-6 shadow-sm"
            >
              <div className="w-11 h-11 bg-premium-50 rounded-lg flex items-center justify-center mb-4 border border-premium-100">
                <Icon className="w-5 h-5 text-premium-600" aria-hidden />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-2">
                {title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </FadeUp>
    </div>
  </section>
);
